var recaptcha_initialized = false;

function initRecaptcha(){
    if(!recaptcha_initialized){
        let recaptcha_site_key_input = $('.js-contact-form .recaptcha_sitekey');
        if(recaptcha_site_key_input.length) {
            const recaptcha_sitekey = recaptcha_site_key_input.val();
            let recaptchaScript = document.createElement('script');
            recaptchaScript.src = 'https://www.google.com/recaptcha/api.js?render=' + recaptcha_sitekey;
            recaptchaScript.defer = true;
            document.body.appendChild(recaptchaScript);
            recaptcha_initialized = true;
        }
    }
}

$(document).on('submit', '.js-contact-form' ,function(e) {
    e.preventDefault();
    const form = $(this);
    const button = $('.js-cf-submit', form);
    const button_text = button.text();
    button.attr('disabled', true);
    button.html('<img class="ml-1 loader" src="'+LOADER+'" alt="ajax loader">');
    let recaptcha_site_key_input = $('.recaptcha_sitekey', form);

    if(recaptcha_site_key_input.length && typeof grecaptcha != 'undefined'){
        const recaptcha_sitekey = recaptcha_site_key_input.val();
        grecaptcha.ready(function() {
            try {
                grecaptcha.execute(recaptcha_sitekey, {action: 'submit'})
                    .then(function(token) {
                        $('.recaptcha_token', form).val(token);
                        console.log('recaptcha_loaded');
                        cf_ajax_call(form, button, button_text);
                    }).catch(function(e){
                        console.error(e);
                        $('.recaptcha_token', form).remove();
                        cf_ajax_call(form, button, button_text);
                    });
            } catch (e) {
                console.error(e);
                $('.recaptcha_token', form).remove();
                cf_ajax_call(form, button, button_text);
            }
        });
    }else{
        cf_ajax_call(form, button, button_text);
    }
});

function cf_ajax_call(form, button, button_text){

    const formData = new FormData(form[0]);

    formData.append('action', 'form_submit');
    formData.append('ajax', true);

    $.ajax({
        type: 'POST',
        url:  BASE_URL+'/wp-admin/admin-ajax.php',
        data: formData,
        dataType: 'json',
        contentType: false,
        processData: false,
        headers: {
            "Accept": "application/json",
        },
        success:  function( response ) {

            if(response){
                const submit_alert = $('.js-cf-submit-alert', form);
                submit_alert.removeClass('alert-danger alert-success alert-warning');

                // let data = $.parseJSON(response);
                let data = response;

                try {

                    if(data.reset_form){
                        form[0].reset();
                    }
                    submit_alert.addClass('alert-'+ data.alert_class).slideUp(function(){
                        submit_alert.text(data.alert_text);
                        submit_alert.slideDown();
                    })

                    if(data.errors){
                        console.error(data.errors);
                    }
                } catch(e) {
                    submit_alert.addClass('alert-danger').slideDown(function(){
                        submit_alert.text( $('.js-cf-error-text').val() );
                    });
                    form[0].reset();
                }
                button.html(button_text).attr('disabled', false);

                /* project cf_submit_fnc */
                if ( typeof after_cf_submit == 'function' ) {
                    after_cf_submit(form, data);
                }
            }
        },
        error: function(xhr, status, error) {
            const submit_alert = $('.js-cf-submit-alert', form);
            submit_alert.addClass('alert-danger').slideDown(function(){
                submit_alert.text( $('.js-cf-error-text').val() );
                button.html(button_text).attr('disabled', false);
            });
            form[0].reset();
        }
    });
    return false;
}
